import * as React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Container from '@material-ui/core/Container';
import DateRangeIcon from '@material-ui/icons/DateRange';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import Header from './Header';

function SportsPerformanceResults({ programs }) {
  return (
    <React.Fragment>
      <Header title="YOUR RESULTS ARE IN!" />
      <Container maxWidth="md">
        <Box my={2}>
          <Card raised>
            <Box p={2}>
              <Typography align="center" variant="h6">
                <strong>Sports Performance Programs</strong>
              </Typography>
              <Box display="flex" justifyContent="center" my={1}>
                <DateRangeIcon style={{ marginRight: '8px' }} />
                <Typography>
                  Training sessions / week: 3
                </Typography>
              </Box>
              <Button
                color="primary"
                href="https://www.californiastrength.com/sports-performance-programs"
                style={{ display: 'flex', margin: '16px auto 0 auto' }}
                target="_blank"
                variant="contained"
              >
                Learn More
              </Button>
            </Box>
            {programs.map(({ programName, promo, thumbnail }) => {
              return (
                <Box mb={2} px={2} key={programName}>
                  <Grid container>
                    <Grid item md={6} xs={12}>
                      <a href="https://www.californiastrength.com/sports-performance-programs" target="_blank">
                        <Paper
                          component="img"
                          elevation={3}
                          src={thumbnail}
                          style={{ display: 'block', margin: '1rem auto', width: '50%' }}
                        />
                      </a>
                    </Grid>
                    <Grid item md={6} style={{ alignSelf: 'center' }} xs={12}>
                      <Typography align="center" variant="h5">
                        <strong>{programName}</strong>
                      </Typography>
                      {programName !== 'Total Speed Program' ? (
                        <Typography align="center">
                          Save 20% on your first month when you use code: <strong>{promo}</strong>
                        </Typography>
                      ): (
                        <Button
                          href="https://www.californiastrength.com/speed-program"
                          style={{ display: 'flex' }}
                        >
                          Learn More
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
          </Card>
        </Box>
      </Container>
    </React.Fragment>
  );
}

export default SportsPerformanceResults;
